module.exports = __webpack_public_path__ + "img/countedServices.3945b620.svg";